import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClickOutsideElementDirective} from './click-outside-element.directive';


@NgModule({
	imports: [
		CommonModule
	],
	exports: [
		ClickOutsideElementDirective
	],
	declarations: [
		ClickOutsideElementDirective
	],
	providers: [],
	entryComponents: []
})
export class ClickOutsideElementModule {
}
